import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import MicrosoftCosmosDbV2ReaderForm from '../forms/microsoft-cosmos-db-v2-reader-form';
import { microsoftCosmosDbV2ReaderValidationSchema } from '../schema/microsoftCosmosDbV2Reader.js';

export default function MicrosoftCosmosDbV2ReaderNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Microsoft Cosmos DB V2 Reader Node Details',
        altText: 'Microsoft Cosmos DB V2 Reader Node',
        defaultLabel: 'Microsoft Cosmos DB V2 Reader Node',
      }}
    >
      <CommonNode
        FormComponent={MicrosoftCosmosDbV2ReaderForm}
        schemaResolver={microsoftCosmosDbV2ReaderValidationSchema}
      />
    </NodeProvider>
  );
}
